import { isEmpty } from 'lodash';

export const VIEW_DASHBOARD = 'VIEW_DASHBOARD';
export const VIEW_MAINTENANCE = 'VIEW_MAINTENANCE';
export const VIEW_EQUIPMENT_FINANCE = 'VIEW_EQUIPMENT_FINANCE';

const checkTenantFeatureFlag = (access, featureFlags) => {
  if (isEmpty(featureFlags)) return false
  const index = featureFlags.findIndex(ff =>  ff.name === access) > -1
  return index
}

export default checkTenantFeatureFlag;
